import React from 'react';
import { Form } from 'semantic-ui-react';

const TenoviBloodPressure = ({
  tenoviDeviceTypes,
  setTenoviDeviceTypes,
}) => {
  return (
    <>
      <Form.Group inline>
        <label style={{ width: '150px' }}>Blood Pressure Cuff</label>
        <Form.Radio
          label="Request"
          value="request"
          checked={tenoviDeviceTypes.TENOVI_BPM.state === 'request'}
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_BPM: {
                ...tenoviDeviceTypes.TENOVI_BPM,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Connect"
          value="connect"
          checked={tenoviDeviceTypes.TENOVI_BPM.state === 'connect'}
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_BPM: {
                ...tenoviDeviceTypes.TENOVI_BPM,
                state: value,
              },
            })
          }
        />
        <Form.Radio
          label="Not needed"
          value="notNeeded"
          checked={tenoviDeviceTypes.TENOVI_BPM.state === 'notNeeded'}
          onChange={(e, { value }) =>
            setTenoviDeviceTypes({
              ...tenoviDeviceTypes,
              TENOVI_BPM: {
                ...tenoviDeviceTypes.TENOVI_BPM,
                state: value,
              },
            })
          }
        />
      </Form.Group>
    </>
  );
};

export default TenoviBloodPressure;
